/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The analysis runs entirely in your browser; nothing is uploaded.`)
};

const es_ra_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. El análisis se ejecuta completamente en tu navegador; nada se carga.`)
};

const de_ra_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Die Analyse läuft vollständig in Ihrem Browser; nichts wird hochgeladen.`)
};

const nl_ra_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. De analyse draait volledig in uw browser; niets wordt geüpload.`)
};

const fr_ra_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. L'analyse s'exécute entièrement dans votre navigateur ; rien n'est téléchargé.`)
};

const it_ra_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. L'analisi viene eseguita interamente nel tuo browser; nulla viene caricato.`)
};

const pt_br2_ra_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A análise é executada inteiramente no seu navegador; nada é enviado.`)
};

const pt_ra_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A análise funciona inteiramente no seu navegador; nada é enviado.`)
};

const ja_ra_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。分析はブラウザで完全に実行されます。何もアップロードされません。`)
};

const zh_ra_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。分析完全在你的浏览器中进行，不会上传任何内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_faq3_a", locale)
	if (locale === "en") return en_ra_faq3_a(inputs)
	if (locale === "es") return es_ra_faq3_a(inputs)
	if (locale === "de") return de_ra_faq3_a(inputs)
	if (locale === "nl") return nl_ra_faq3_a(inputs)
	if (locale === "fr") return fr_ra_faq3_a(inputs)
	if (locale === "it") return it_ra_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_ra_faq3_a(inputs)
	if (locale === "pt") return pt_ra_faq3_a(inputs)
	if (locale === "ja") return ja_ra_faq3_a(inputs)
	return zh_ra_faq3_a(inputs)
};